import _post from "./Post"
import constantURI from "../URI"
import Authenticate from "./MedRepAuthenticate"
const Collecting = async () => {
    const token = JSON.parse(localStorage.getItem("Token"));
    const user = JSON.parse(localStorage.getItem("User"));
    const isSupervisor = JSON.parse(localStorage.getItem("isSupervisor"));
    const readURL = constantURI() + "odooController/MedRepRead";
    const groupArrayOfObjects = (list, key) => {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }
    const clientsBody = {
        jsonrpc: "2.0",
        params: {
            method: "search_read",
            model: "res.partner",
            args: [],
            kwargs: {
                fields: ["name", "street", "phone", "potential", "cf", "state_id", "x_specialty_id", "clienttype", "x_month_visits", "x_city_id"],
                domain: [["x_repuser", "=", user]]
            }
        },
        "token": token
    }
    const repsBody = {
        "jsonrpc": "2.0",
        "params": {
            "method": "search_read",
            "model": "res.partner",
            "args": [],
            "kwargs": {
                "fields": ["name"],
                "domain": [["x_salesrepresentative", "=", true]]
            }
        },
        "token": token
    }
    const specialtiesBody = {
        "jsonrpc": "2.0",
        "params": {
            "method": "search_read",
            "model": "x_specialties",
            "args": [],
            "kwargs": {
                "fields": ["x_name"]
            }
        },
        "token": token
    }
    const potentialBody = {
        "jsonrpc": "2.0",
        "params": {
            "method": "search_read",
            "model": "edm.potential",
            "args": [],
            "kwargs": {
                "fields": ["name"]
            }
        },
        "token": token
    }
    const areaBody = {
        "jsonrpc": "2.0",
        "params": {
            "method": "search_read",
            "model": "res.country.state",
            "args": [],
            "kwargs": {
                "fields": ["name"]
            }
        },
        "token": token
    }
    const subareaBody = {
        "jsonrpc": "2.0",
        "params": {
            "method": "search_read",
            "model": "x_res.city",
            "args": [],
            "kwargs": {
                "fields": ["x_name", "x_country_state_id"],
            }
        },
        "token": token
    }
    const productsBody = {
        jsonrpc: "2.0",
        params: {
            method: "search_read",
            model: "product.product",
            args: [],
            kwargs: {
                fields: ["default_code", "name"]
            }
        },
        "token": token
    }
    const stockBody = {
        jsonrpc: "2.0",
        params: {
            method: "search_read",
            model: "x_stock",
            args: [],
            kwargs: {
                fields: ["x_product_id", "remaining_stock", "x_partner_id"],
                domain: [["x_partner_id", "=", user]],
                limit: 4,
                offset: 0,
                order: "create_date DESC"
            }
        },
        "token": token
    }
    const rep = {
        "jsonrpc": "2.0",
        "params": {
            "method": "search_read",
            "model": "res.partner",
            "args": [],
            "kwargs": {
                "fields": ["name"],
                "domain": [["name", "=", user]]
            }
        },
        "token": token
    }
    const repSupervisor = {
        "jsonrpc": "2.0",
        "params": {
            "method": "search_read",
            "model": "res.users",
            "args": [],
            "kwargs": {
                "fields": ["name", "supervisor"],
                "domain": [["name", "=", user]]
            }
        },
        "token": token
    }
    const skillsBody = {
        "jsonrpc": "2.0",
        "params": {
            "method": "search_read",
            "model": "coachingskills",
            "args": [],
            "kwargs": {
                "fields": ["name"],
            }
        },
        "token": token
    }
    const currentRepBody = {
        "jsonrpc": "2.0",
        "params": {
            "method": "search_read",
            "model": "res.users",
            "args": [],
            "kwargs": {
                "fields": ["name", "supervisor"],
                "domain": [["name", "=", user]]
            }
        },
        "token": token
    }
    const typeBody = {
        "jsonrpc": "2.0",
        "params": {
            "method": "search_read",
            "model": "x_event.type",
            "args": [],
            "kwargs": {
                "fields": ["x_name"]
            }
        },
        "token": token
    }
    var currentRep = 0;
    var dailySchedule = [];
    var coachDay = false;
    var clients = [];
    var coachingRequests = [];
    var visits = [];
    var activities = [];
    var authenticate = false;
    var Reps = [];
    await Authenticate().then((response) => { authenticate = response });
    if (authenticate) {
        await _post(readURL, clientsBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('HCPs', JSON.stringify(data.result));
                clients = data.result;
            })
        })
        await _post(readURL, repsBody).then((response) => {
            return response.json().then((data) => {
                Reps = data.result;
                localStorage.setItem('Reps', JSON.stringify(data.result));
                Reps.forEach(async (item, index, arr) => {
                    const clientsBodySP = {
                        jsonrpc: "2.0",
                        params: {
                            method: "search_read",
                            model: "res.partner",
                            args: [],
                            kwargs: {
                                fields: ["name", "street", "phone", "potential", "state_id", "x_specialty_id", "clienttype"],
                                domain: [["x_repuser", "=", item.name]]
                            }
                        },
                        "token": token
                    }
                    await _post(readURL, clientsBodySP).then((response) => {
                        return response.json().then(async (data) => {
                            const tempClients = clients;
                            await tempClients.push.apply(tempClients, data.result);
                            localStorage.setItem('HCPsSupervisor', JSON.stringify(tempClients));
                        })
                    })
                })
            })
        })
        await _post(readURL, specialtiesBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('Specialties', JSON.stringify(data.result));
            })
        })
        await _post(readURL, potentialBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('Potential', JSON.stringify(data.result));
            })
        })
        await _post(readURL, areaBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('Area', JSON.stringify(data.result));
            })
        })
        await _post(readURL, subareaBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('Subareas', JSON.stringify(data.result));
            })
        })
        await _post(readURL, productsBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('ProductsList', JSON.stringify(data.result));
            })
        })
        await _post(readURL, stockBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('Products', JSON.stringify(data.result));
            })
        })
        await _post(readURL, rep).then((response) => {
            return response.json().then(async (data) => {
                localStorage.setItem('UserDetail', JSON.stringify(data.result));
            })
        })
        await _post(readURL, repSupervisor).then((response) => {
            return response.json().then(async (data) => {
                localStorage.setItem('Supervisor', JSON.stringify(data.result));
            })
        })
        await _post(readURL, skillsBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('Skills', JSON.stringify(data.result));
            })
        })
        await _post(readURL, currentRepBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('CurrentUserId', JSON.stringify(data.result));
                currentRep = data.result[0].id;
            })
        })
        const coachingBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "coaching",
                args: [],
                kwargs: {
                    fields: ["date"],
                    domain: [["supervisor_id", "=", currentRep], ["status", "=", "approved"], ["date", "=", new Date().toISOString().substring(0, 10)]]
                }
            },
            "token": token
        }
        const coachingRequestBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "coaching",
                args: [],
                kwargs: {
                    fields: ["date", "status"],
                    domain: [["supervisor_id", "=", currentRep]]
                }
            },
            "token": token
        }
        await _post(readURL, coachingBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('Coaching', JSON.stringify(data.result));
            })
        })
        await _post(readURL, coachingRequestBody).then((response) => {
            return response.json().then((data) => {
                coachingRequests = data.result;
                localStorage.setItem('CoachingRequests', JSON.stringify(data.result));
                coachingRequests.forEach((item, index) => {
                    if (item.date === new Date().toISOString().substring(0, 10)) {
                        coachDay = true;
                    }
                })
            })
        })
        if ((!isSupervisor && !coachDay) || isSupervisor) {
            dailySchedule = [{ name: "Visits" }, { name: "Activities" }];
        }
        else if (!isSupervisor && coachDay) {
            dailySchedule = [{ name: "Coaching" }, { name: "Activities" }];
        }

        dailySchedule.map(async (item, index, arr) => {
            if (isSupervisor) {
                const visitsBody = {
                    jsonrpc: "2.0",
                    params: {
                        method: "search_read",
                        model: "calendar.event",
                        args: [],
                        kwargs: {
                            fields: ["name", "x_status", "start_datetime", "partner_ids", "x_fbgeneral", "supdatein", "x_specialrequest_to_delivery"],
                            domain: [["partner_ids", "=", user], ["x_status", "=", index], ["start_date", "=", new Date().toISOString().substring(0, 10)]]
                        }
                    },
                    "token": token
                }
                await _post(readURL, visitsBody).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result.length !== 0)
                            visits = [...visits, ...data.result];
                        localStorage.setItem('Visits', JSON.stringify(visits));
                    })
                })
            }
            else {
                const reps = JSON.parse(localStorage.getItem("Reps"));
                reps.map(async (item2) => {
                    const visitsBody = {
                        jsonrpc: "2.0",
                        params: {
                            method: "search_read",
                            model: "calendar.event",
                            args: [],
                            kwargs: {
                                fields: ["name", "x_status", "start_datetime", "partner_ids", "x_fbgeneral", "supdatein", "x_specialrequest_to_delivery"],
                                domain: [["partner_ids", "=", item2.name], ["x_status", "=", index], ["start_date", "=", new Date().toISOString().substring(0, 10)]]
                            }
                        },
                        "token": token
                    }
                    await _post(readURL, visitsBody).then((response) => {
                        return response.json().then(async (data) => {
                            if (data.result.length !== 0)
                                visits = [...visits, ...data.result];
                            localStorage.setItem('Visits', JSON.stringify(visits));
                        })
                    })
                })
            }
            const ActivityBody = {
                jsonrpc: "2.0",
                params: {
                    method: "search_read",
                    model: "event.event",
                    args: [],
                    kwargs: {
                        "fields": ["name", "date_begin", "x_status"],
                        "domain": [["x_repuserid", "=", user], ["date_begin", "=", new Date().toISOString().substring(0, 10)], ["x_status", "=", index]]
                    }
                },
                "token": token
            }
            await _post(readURL, ActivityBody).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result.length !== 0)
                        activities = [...activities, ...data.result];
                    localStorage.setItem('Activities', JSON.stringify(activities));
                })
            })

        })
        const RepsBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "medrepsettings",
                "args": [],
                "kwargs": {
                    "fields": ["in_time", "out_time", "out_of_rout_visit"],
                }
            },
            "token": token
        }
        await _post(readURL, RepsBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('Limits', JSON.stringify(data.result));
            })
        })
        const plannedVisitsBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "calendar.event",
                args: [],
                kwargs: {
                    fields: ["name", "x_status", "start_datetime", "start_date", "partner_ids"],
                    domain: [["x_status", "=", "0"], ["partner_ids", "=", user]],
                    order: "start_date DESC"
                }
            },
            "token": token
        }
        await _post(readURL, plannedVisitsBody).then((response) => {
            return response.json().then(async (data) => {
                const groups = groupArrayOfObjects(data.result, 'start_date');
                localStorage.setItem('PlannedVisits', JSON.stringify(groups));
            })
        })
        const clientDetailBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "res.partner",
                args: [],
                kwargs: {
                    fields: ["name", "clienttype", "x_specialty_id", "x_availability", "potential", "cf", "brick", "state_id", "x_city_id", "street", "phone", "mobile", "email", "birthday", "x_clientitems_ids", "x_month_visits", "x_deal", "x_workdays", "x_workhours", "prefered_visit_time"],
                    domain: [["x_repuser", "=", user]]
                }
            },
            "token": token
        }
        await _post(readURL, clientDetailBody).then((response) => {
            return response.json().then(async (data) => {
                await localStorage.setItem('HCPDetail', JSON.stringify(data.result));
            })
        })
        await _post(readURL, typeBody).then((response) => {
            return response.json().then((data) => {
                localStorage.setItem('MeetingType', JSON.stringify(data.result));
            })
        })
        return true;
    }
    else return false;
}
export default Collecting